<template>
	<div class="crumbs_template">
		<div class="crumbs_box">
			<div class="title pointer blue" @click="go_page('home')">
				{{ $t('homePage.nav.Home') }}
			</div>
			<div class="validItem" v-for="(item, index) in validParts" :key="index">
				<i class="el-icon-arrow-right el-icon" v-if="item != 'home'"></i>
				<div class="title" v-if="item != 'home'" :class="get_last_item(index) ? 'pointer' : 'default gray'" @click="handleClick(item, index)">
					{{ item }}
				</div>
			</div>
		</div>
		<!-- <div class="crumbs_box">
			<div class="title pointer blue" @click="go_page('home')">
				{{ $t('homePage.nav.Home') }}
			</div>
			<i class="el-icon-arrow-right el-icon"></i>
			<
			<div class="title" @click="go_page('home')">
				{{ titleName }}
			</div>
			<i class="el-icon-arrow-right el-icon"></i>
			<div class="title" @click="go_page('home')">
				{{ titleName }}
			</div>
		</div> -->
	</div>
</template>

<script>

let that;
export default {
	name: 'Crumbs',

	// props: {
	// 	Loading: {
	// 		type: Boolean,
	// 		default: false,
	// 	},
	// 	calling_modules: {
	// 		type: String,
	// 		default: ""
	// 	},
	// },
	data() {
		return {
			titleName: "999999999",
			validParts:[],
		}
	},
	
	// 监听
	watch: {
		'$route': {
		   handler (newValue, oldValue) {
				this.set_title_name()
		   },
		   deep: true
		}
	},
	
	// beforeCreate() {
		
	// }
	
	beforeRouteEnter(to, from, next) {
	   // 这里不能直接访问 this，需要通过 next 回调来访问
	   // next(vm => {
	   //    that.previousRoute = from;
	   // });
	},
	
	created () {
		that = this
	},
  
	mounted() {
		this.set_title_name()
	},
  
	methods:{
		get_last_item(index) {
		   return this.validParts.length!== index + 1;
		},
		
		handleClick(item, index) {
         let clickName = item;
         if (this.get_last_item(index)) {
				this.go_page(clickName);
            // const parts = item.split('-');
            // if (parts.length > 1) {
            //    clickName = parts[0];
            // }
         }else{
				this.go_page("not");
			}
      },
		  
        go_page(name) {
            // console.log(name);
            if (name === "not") {
               return;
            }
            let routeConfig = {};
            const parts = name.split('-');
            const baseName = parts[0];
            const paramValue = parts[1];
				console.log(baseName	)
				console.log(this.$route.name	)
				
				let path = this.$router.currentRoute.path;
				console.log(this.$router.currentRoute.path)
				
				console.log(this.validParts)
				
				let index = path.indexOf(name);
				let result = null
				if (index!== -1) {
				   result = path.slice(1, (index-1));
				}
				console.log(result);
				
            switch (baseName) {
               case 'users':
                  routeConfig = {
                     name: 'users',
                     params: {
                        user_id: paramValue
                     },
                  };
                  break;
               case 'report':
                  routeConfig = {
                     name: 'post-report',
                     params: {
                        post_id: paramValue
                     }
                  };
                  break;
               case 'details':
                  routeConfig = {
                     name: 'post-details',
                     params: {
                         post_id: paramValue
                     }
                  };
                  break;
               default:
                  routeConfig = {
                     name: name,
                     // params: {
                     //    post_id: paramValue
                     // }
                  };
						break;
            }
				

				console.log(baseName)
				console.log(routeConfig)
				if(result){
					routeConfig.params.previous = result
				}
				console.log(routeConfig)
            this.$router.push(routeConfig);
        },
		
		//打开
		// go_page(name){
		// 	console.log(name)
		// 	if(name == "not"){ return }
		// 	this.$router.push({
		// 		// path: name
		// 		// name: name ? name : "home",
		// 		// params: {
		// 		// 	user_id: item.user_id,
		// 		// 	nickname: item.nickname,
		// 		// }
		// 	})
		// },
		
		//去登录
		set_title_name(){
			console.log(this.$router.options.routes)
			let routes = this.$router.options.routes
			console.log(this.$router)
			let currentRouteName = this.$router.currentRoute.name
			console.log(this.previousRoute)
			console.log(this.$router.currentRoute.path)
			
			const str = this.$router.currentRoute.path;
			const parts = str ? str.split('/') : [];
			this.validParts = parts.filter(part => part);
			console.log(this.validParts);
		},
	}
}
</script>

<style lang="less" scoped>
	.crumbs_template{
		margin-top: 10px;
		width: 100%;
		display: flex;
		justify-content: center;
		position: sticky;
		// top: 90px;
		z-index: 999;
	}
	.crumbs_box{
		background-color: #ffffff;
		width: 100%;
		max-width: 1280px;
		border-radius: 8px;
		padding: 10px;
		display: flex;
		color: #333333;
		align-items: center;
		.title{
			font-size: 12px;
			line-height: 1.3;
		}
	}
	.validItem{
		display: flex;
	}
	.el-icon{
		font-size: 12px;
		line-height: 1.3;
		margin: 0px 2px;
	}
	.pointer{
		cursor: pointer;
	}
	.default{
		cursor: default;
	}
	.blue{
		color: #06f;
		// color: #2094FA;
	}
	.gray{
		color: #666666;
		// color: #999999;
	}
</style>
